<template>
  <b-modal 
    id="company-info-modal"
    size="lg"
    ref="modal"
    title="Ustawienia firmy"
    @hidden="onClose"
    @show="onShow"
  >
    <ValidationObserver
      id="companyForm"
      ref="formValidation"
      tag="form"
      @submit.prevent="onSubmit"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="section-title">Dane firmy:</div>
          <div class="form-group row">
            <label for="company_name" class="col-lg-3 col-form-label">Nazwa firmy:</label>
            <div class="col-lg-8  align-self-center">
              <ValidationProvider
                name="company_name"
                rules="required|max:191"
                v-slot="validationContext"
              >
                <b-form-input
                  id="company_name"
                  v-model="form.name"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label for="company_country" class="col-lg-3 col-form-label">Kraj:</label>
            <div class="col-lg-8">
              <ValidationProvider
                name="company_country"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-select 
                  id="company_country"
                  v-model="form.country"
                  :options="availableCountries"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label for="vatnumber" class="col-lg-3 col-form-label">NIP:</label>
            <div class="col-lg-8">
              <ValidationProvider
                name="vatnumber"
                rules="required|max:24"
                v-slot="validationContext"
              >
                <b-form-input
                  id="vatnumber"
                  v-model="form.vatnumber"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="section-title">Adres siedziby firmy:</div>
          <div class="form-group row">
            <label for="address" class="col-lg-3 col-form-label">
              Ulica, nr domu/nr
              <br />lokalu:
            </label>
            <div class="col-lg-8  align-self-center">
              <ValidationProvider
                name="address"
                rules="required|max:191"
                v-slot="validationContext"
              >
                <b-form-input
                  id="address"
                  v-model="form.address"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label for="city" class="col-lg-3 col-form-label">Miasto:</label>
            <div class="col-lg-8">
              <ValidationProvider
                name="city"
                rules="required|max:191"
                v-slot="validationContext"
              >
                <b-form-input
                  id="city"
                  v-model="form.city"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label for="postalcode" class="col-lg-3 col-form-label">Kod pocztowy:</label>
            <div class="col-lg-8  align-self-center">
              <ValidationProvider
                name="postalcode"
                rules="required|max:12"
                v-slot="validationContext"
              >
                <b-form-input
                  id="postalcode"
                  v-model="form.postalcode"
                  type="text"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <!-- Opcje -->
          <div class="section-title">Opcje:</div>
          <div class="form-group row">
            <label for="company_currency" class="col-lg-3 col-form-label">Waluta:</label>
            <div class="col-lg-8">
              <ValidationProvider
                name="company_currency"
                rules="required"
                v-slot="validationContext"
              >
                <b-form-select 
                  id="company_currency"
                  v-model="form.currency"
                  :options="availableCurrencies"
                  :state="getValidationState(validationContext)"
                ></b-form-select>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group row">
            <label for="vat_rate" class="col-lg-4 col-form-label">Domyślna stawka VAT:</label>
            <div class="col-lg-4  align-self-center">
              <ValidationProvider
                name="vat_rate"
                rules="required|max_value:100|min_value:0|numeric"
                v-slot="validationContext"
                mode="lazy"
              >
                <b-form-input
                  id="vat_rate"
                  v-model="form.vat_rate"
                  step="1"
                  min="0"
                  max="100"
                  type="number"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <!-- Skonto -->
          <div class="section-title">Skonto:</div>
          <div class="form-group row">
            <label class="col-md-0 col-lg-4 col-form-label checkbox" for="options_skonto"></label>
            <div class="pl-3">
              <b-form-checkbox
                id="options_skonto"
                ref="skonto"
                v-model="form.options.skonto"
                name="options_skonto"
                value="1"
                unchecked-value="0"
              >Aktywuj "Skonto"</b-form-checkbox>
            </div>
          </div>
          <div :class="[form.options.skonto == 1 ? 'visible' : 'invisible', 'form-group', 'row']">
            <label for="options_skonto_value" class="col-lg-4 col-form-label">
              Domyślny procent skonto
              %:
            </label>
            <div class="col-lg-4 align-self-center">
              <ValidationProvider
                :disabled="form.options.skonto == 1 ? false : true"
                name="options_skonto_value"
                rules="required|max_value:100|min_value:0|numeric"
                v-slot="validationContext"
                mode="lazy"
              >
                <b-form-input
                  id="options_skonto_value"
                  v-model="form.options.skonto_value"
                  type="number"
                  step="1"
                  min="0"
                  max="100"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
          <div :class="[form.options.skonto == 1 ? 'visible' : 'invisible', 'form-group', 'row']">
            <label
              for="options_skonto_days"
              class="col-lg-4 col-form-label"
            >Skonto liczba dni:</label>
            <div class="col-lg-4  align-self-center">
              <ValidationProvider
                :disabled="form.options.skonto == 1 ? false : true"
                name="options_skonto_days"
                rules="required|min_value:0|numeric"
                v-slot="validationContext"
                mode="lazy"
              >
                <b-form-input
                  id="options_skonto_days"
                  v-model="form.options.skonto_days"
                  type="number"
                  step="1"
                  min="0"
                  max="191"
                  :state="getValidationState(validationContext)"
                ></b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="companyForm">{{ form.id ? 'Zapisz' : 'Stwórz' }}</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CompaniesModalFormInfo",
  props: {
    company: Object,
  },
  data() {
    return {
      form: {
        options: {}
      },
      availableCountries: [
        { value: 'PL', text: 'Polska' },
        { value: 'DE', text: 'Niemcy' }
      ],
      availableCurrencies: [
        { value: 'EUR', text: 'EUR' },
        { value: 'PLN', text: 'PLN' },
        { value: 'USD', text: 'USD' },
        { value: 'GBP', text: 'GBP' },
        { value: 'CHF', text: 'CHF' },
        { value: 'DKK', text: 'DKK' },
        { value: 'NOK', text: 'NOK' },
        { value: 'SEK', text: 'SEK' },
        { value: 'UAH', text: 'UAH' },
        { value: 'RUR', text: 'RUR' }
      ]
    };
  },
  methods: {
    ...mapActions("company", ["getCompanies", "createCompany", "updateCompany"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.$_.isEmpty(this.company) === false) {
        this.form = Object.assign({}, this.company);
      }
    },
    onClose() {
      this.form = {
        options: {}
      };
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.formValidation.validate().then(success => {
        if (!success) {
          return;
        }

        let query = this.copyForm();
        this.$Progress.start();

        if (query.id != null) {
          // -----[ UPDATE ]-----
          this.updateCompany({id: query.id, data: query})
            .then(() => {
              this.$emit("onSubmit");
            })
            .catch(error => {
              this.$refs.formValidation.setErrors(error.response.data.fields);
            });
        } else {
          // -----[ CREATE ]-----
          this.createCompany(query)
            .then(() => {
              this.$emit("onSubmit");
            })
            .catch(error => {
              this.$refs.formValidation.setErrors(error.response.data.fields);
            });
        }
      });
    },
    copyForm() {
      let query = {};
      this.$_.forEach(this.form, (item, key) => {
        query[key] = item;
      });

      if (query.options.skonto == 0) {
        query.options.skonto_value = 0;
        query.options.skonto_days = 0;
      }

      return query;
    },
  }
};
</script>

